import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/logo-1.png';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/page-header-bg.jpg';
import CtaThree from '../../components/Common/CtaSection/CtaThree';
import TestimonialsMain from './TestimonialsMain';


// Breadcrumbs Background Image

const Testimonials = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <React.Fragment>
        <Header
            navImg={navImg1}
            parentMenu='testimonials'
            activeMenu="/testimonials"
        />
        {/* SiteBreadcrumb */}
        <SiteBreadcrumb
            pageTitle="Testimonials"
            pageName="Testimonials"
            breadcrumbsImg={bannerbg}
        />
        {/* SiteBreadcrumb */}
        <TestimonialsMain/>
        {/*cta-section */}
        <CtaThree/>
        {/*cta-section end */}
        <BackToTop scroll={isVisible} />
        <FooterTwo />
    </React.Fragment>
    );
}

export default Testimonials;